import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const slaService = {
  listPolicies: async () => (await apiClient.get(ENDPOINTS.slaPolicies)).data,
  upsertPolicy: async (payload) => (await apiClient.put(ENDPOINTS.slaPolicies, payload)).data,
  deletePolicy: async (id) => (await apiClient.delete(ENDPOINTS.slaPolicy(id))).data,
  listStatuses: async () => (await apiClient.get(ENDPOINTS.statuses)).data,
  createStatus: async (payload) => (await apiClient.post(ENDPOINTS.statuses, payload)).data,
  updateStatus: async (id, payload) => (await apiClient.patch(ENDPOINTS.status(id), payload)).data,
  deleteStatus: async (id) => (await apiClient.delete(ENDPOINTS.status(id))).data,
  listPriorities: async () => (await apiClient.get(ENDPOINTS.priorities)).data,

  listTransitions: async () => (await apiClient.get(ENDPOINTS.workflowTransitions)).data,
  setTransitions: async (transitions) =>
    (await apiClient.put(ENDPOINTS.workflowTransitions, { transitions })).data,

  getBusinessHours: async () => (await apiClient.get(ENDPOINTS.slaBusinessHours)).data,
  setBusinessHours: async (days) => (await apiClient.put(ENDPOINTS.slaBusinessHours, { days })).data,

  listHolidays: async () => (await apiClient.get(ENDPOINTS.slaHolidays)).data,
  addHoliday: async (payload) => (await apiClient.post(ENDPOINTS.slaHolidays, payload)).data,
  removeHoliday: async (id) => (await apiClient.delete(ENDPOINTS.slaHoliday(id))).data,

  runEscalationCheck: async () => (await apiClient.post(ENDPOINTS.slaRunEscalationCheck)).data,
};

export const notificationService = {
  list: async (unreadOnly = false) =>
    (await apiClient.get(ENDPOINTS.notifications, { params: { unread_only: unreadOnly } })).data,
  markRead: async (id) => (await apiClient.patch(ENDPOINTS.notificationRead(id))).data,
  markAllRead: async () => (await apiClient.post(ENDPOINTS.notificationsMarkAllRead)).data,
};
